import React from "react";
import classNames from "classnames";

import { Context } from "@scenes/workloads/context";
import { useConstraints } from "../../../constraintsOverlay";
import { Props } from "./types";
import { Handle } from "./handle";
import styles from "./styles.scss";

function Constrainable({ element, constraints, children }: Props) {
  const { origin, target } = useConstraints();
  const { hoveredElement } = React.useContext(Context);

  return (
    <div
      className={classNames(styles.constrainable, {
        [styles.origin]: origin && element.uuid === origin.uuid,
        [styles.target]: target && element.uuid === target.uuid,
        [styles.hovered]:
          hoveredElement && hoveredElement.uuid === element.uuid,
      })}
    >
      <Handle element={element} constraints={constraints} direction="left" />
      {children}
      <Handle element={element} constraints={constraints} direction="right" />
    </div>
  );
}

export { Constrainable };
